import { Link } from 'react-router-dom';
import styles from './flowFullPage.module.css';

/**
 * Compact icon-only navigation to the dashboard (full-page entry/exit flows).
 * @param {object} props
 * @param {string} props.ariaLabel Localized accessible name (e.g. t('entryPageBackToDashboard')).
 * @param {'panel'|'toolbar'} props.variant paneled button vs borderless toolbar (TopNavBar)
 */
export const FlowPageBackLink = ({ ariaLabel, variant = 'panel' }) => (
  <Link
    className={
      variant === 'toolbar' ? `${styles.flowBackLinkToolbar} ${styles.flowBackIconControl}` : styles.flowBackLink
    }
    to="/dashboard"
    aria-label={ariaLabel}
    title={ariaLabel}
  >
    <span className={styles.flowBackIconWrap} aria-hidden>
      <svg
        className={styles.flowBackIcon}
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.5 19.5L8 12l7.5-7.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  </Link>
);
